import { Box, Stack, Button, Tooltip, Typography, FormControlLabel, Checkbox, TextField, Autocomplete } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation'
import Loader from '../../../Components/Loader'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'

const fieldLimits = {
    roomWardNo: 50,
    blockFloorNo: 50,
}

export default function ConsultRoomConfig(props) {
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isDelete, setisDelete] = useState(false);
    const [deletedID, setdeletedID] = useState(null);
    const [isloader, setisloader] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [EditID, setEditID] = useState(null);
    const [EditPopup, setEditPopup] = useState(false);
    const [formState, setFormState] = useState({
        roomWardNo: '',
        blockFloorNo: '',
        departmentName: null,
        doctorName: null
    });
    const [ListState, setListState] = useState({
        DepartmentList: [],
        DoctorList: [],
        ConsultRoomList: []
    });
    let commonDisable = props?.Access?.editAccess

    useEffect(() => {
        fetchAndSetList('DepartmentList', Serviceurls.MRD_DEPARTMENT_GET_POST);
        fetchAndSetList('DoctorList', Serviceurls.FO_CONFIG_OPDOCTORNAME);
        fetchAndSetList('ConsultRoomList', Serviceurls.MRD_CONSULT_ROOM_GET_POST);
    }, [])

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const fetchAndSetList = async (stateKey, url) => {
        try {
            setisloader(true);
            const response = await RestAPIService.getAll(url);
            if (response?.data?.status === 'success') {
                const listData = response?.data?.data || [];
                let filteredDate = []
                if (stateKey === 'DepartmentList') {
                    filteredDate = listData.filter(item => item.is_active === true)
                }
                setListState((prev) => ({
                    ...prev,
                    [stateKey]: stateKey === 'DepartmentList' ? filteredDate : listData,
                }));
            }
        } catch (e) {
            const msg = e?.response?.data?.status === 'fail' ? e.response.data.message : e.message;
            errorMessage(msg);
        } finally {
            setisloader(false);
        }
    };

    const AddConsultRoomMaster = () => {
        try {
            if (!formState?.roomWardNo || CommonValidation.removeSpace(formState?.roomWardNo) == "" || !formState?.blockFloorNo || CommonValidation.removeSpace(formState?.blockFloorNo) == ""
                || !formState?.departmentName || !formState?.doctorName) {
                return errorMessage('Please Enter Madatory Fields');
            }
            let data = {
                room_no: ((formState?.roomWardNo ?? '').trim()),
                floor_no: ((formState?.blockFloorNo ?? '').trim()),
                department: formState?.departmentName?.id,
                doctor: formState?.doctorName?.doctor_id,
                is_active: isActive,
                ...(EditID && { id: EditID })
            }
            let RestAPI = EditID ? RestAPIService.updateWithOutId(data, Serviceurls.MRD_CONSULT_ROOM_GET_POST) : RestAPIService.create(data, Serviceurls.MRD_CONSULT_ROOM_GET_POST)
            setisloader(true)
            RestAPI.then((response) => {
                if (response.data?.status === 'success') {
                    successMessage(response.data?.message)
                    setFormState({
                        roomWardNo: '',
                        blockFloorNo: '',
                        departmentName: null,
                        doctorName: null
                    });
                    setEditPopup(false)
                    setIsActive(true)
                    setEditID(null)
                    fetchAndSetList('ConsultRoomList', Serviceurls.MRD_CONSULT_ROOM_GET_POST);
                    setisloader(false)
                }
            }).catch(e => {
                setisloader(false)
                if (e?.response?.data?.status === 'fail') {
                    errorMessage(e.response.data.message)
                } else {
                    errorMessage(e?.message || e?.response?.data?.message)
                }
            })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const tableView = () => {

        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
                </Box>

            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = ListState?.ConsultRoomList?.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        ListState?.ConsultRoomList?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'floor_no', headerName: 'Block / Floor', flex: 0.4,
                renderCell: (params) => (params.row.floor_no ? params.row.floor_no?.length > 70 ?
                    <Tooltip placement="top" title={params.row.floor_no}><Typography fontSize={'0.9vw'}>{params.row.floor_no?.slice(0, 68) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.floor_no}</Typography> : '-')
            },
            {
                field: 'room_no', headerName: 'Ward / Room', flex: 0.4,
                renderCell: (params) => (params.row.room_no ? params.row.room_no?.length > 70 ?
                    <Tooltip placement="top" title={params.row.room_no}><Typography fontSize={'0.9vw'}>{params.row.room_no?.slice(0, 68) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.room_no}</Typography> : '-')
            },
            {
                field: 'depart_name', headerName: 'Department', flex: 0.4,
                renderCell: (params) => (params.row.depart_name ? params.row.depart_name?.length > 70 ?
                    <Tooltip placement="top" title={params.row.depart_name}><Typography fontSize={'0.9vw'}>{params.row.depart_name?.slice(0, 68) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.depart_name}</Typography> : '-')
            },
            {
                field: 'doctor_name', headerName: 'Doctor', flex: 0.4,
                renderCell: (params) => (params.row.doctor_name ? params.row.doctor_name?.length > 70 ?
                    <Tooltip placement="top" title={params.row.doctor_name}><Typography fontSize={'0.9vw'}>{params.row.doctor_name?.slice(0, 68) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.doctor_name}</Typography> : '-')
            },
            ...(commonDisable ? [{
                field: 'action', headerName: 'Action', flex: 0.2, headerAlign: "center", align: "center",
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw" onClick={() => {
                                setFormState({
                                    roomWardNo: params.row.room_no || '',
                                    blockFloorNo: params.row.floor_no || '',
                                    departmentName: params.row.depart_id ? ListState?.DepartmentList?.find((item) => item.id == params.row.depart_id) : null,
                                    doctorName: params.row.doc_id ? ListState?.DoctorList?.find((item) => item.doctor_id == params.row.doc_id) : null
                                });
                                setEditID(params.row.id);
                                setIsActive(params.row.is_active || false);
                            }} />
                        </Stack>
                    </Stack>)

            }] : [])
        ]
        return (
            <Box sx={{ height: '64vh' }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onRowSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={ListState?.ConsultRoomList}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    pageSizeOptions={[10, 20, 30]}
                    pagination
                    paginationMode="client"
                    paginationModel={{
                        page: page,
                        pageSize: pageSize
                    }}
                    onPaginationModelChange={(model) => {
                        setpage(model.page)
                        setpageSize(model.pageSize)
                    }}
                    getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                    sx={{
                        "& .gray-row .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                    headerHeight={40}
                    density='compact'
                    disableRowSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const PopupClose = () => {
        setisDelete(false);
        setdeletedID(null);
        setEditPopup(false)
    }

    const deleteConsultRoomMaster = () => {
        try {
            let ID = deletedID ? [deletedID] : (delIDs || [])
            RestAPIService.delete(Serviceurls.MRD_CONSULT_ROOM_GET_POST + `?id=${ID}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        fetchAndSetList('ConsultRoomList', Serviceurls.MRD_CONSULT_ROOM_GET_POST);
                        setdelIDs([]);
                        setCheckBoxList([]);
                        setdeletedID(null);
                        setisDelete(false)
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }


    const autoComplete = (label, name, optionName, Options, width) => {
        return (
            <Autocomplete
                size='small'
                options={Options}
                getOptionLabel={(option) => option?.[optionName]?.toString?.() ?? ""}
                value={formState?.[name] || null}
                onChange={(event, newValue) => {
                    setFormState({
                        ...formState,
                        [name]: newValue
                    })
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        sx={{ width: width, marginRight: '0.3vw' }}
                    />
                )}
            />
        )
    }

    const textBox = (label, name, val, width, disable = false) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    autoComplete='off'
                    value={val || ''}
                    id="drug-master"
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    onChange={(e) => {
                        const { value } = e.target;
                        if (value === "" || value.length <= (fieldLimits[name] || 50)) {
                            setFormState({
                                ...formState,
                                [name]: e.target.value
                            });
                        }
                    }}
                    variant="outlined"
                />
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '13vh', width: '93vw', alignContent: 'center', backgroundColor: "white", padding: "0.5vw" }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row' }}>
                    {textBox("Block/Floor*", 'blockFloorNo', formState?.blockFloorNo, '15vw', false)}
                    {textBox("Ward/Room*", 'roomWardNo', formState?.roomWardNo, '15vw', false)}
                    {autoComplete("Select Department *", 'departmentName', 'department_name', ListState?.DepartmentList, '15vw')}
                    {autoComplete("Select Doctor *", 'doctorName', 'doctor_name', ListState?.DoctorList, '15vw')}
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginTop: "0.5vw" }}>
                    <Box sx={{ display: 'flex' }}>
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} disabled={!EditID} size='small' />} label={"Active"} />
                    </Box>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', }}>
                        <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw', marginRight: "0.5vw" }}
                            disabled={!commonDisable}
                            onClick={() => {
                                setFormState({
                                    roomWardNo: '',
                                    blockFloorNo: '',
                                    department: null,
                                    doctor: null
                                });
                                setIsActive(true)
                                setEditID(null)
                            }}>Clear</Button>
                        <Button size='small' variant='contained' disabled={!commonDisable} sx={{ textTransform: 'capitalize', width: '7vw' }}
                            onClick={() => { EditID && !isActive ? setEditPopup(true) : AddConsultRoomMaster() }}>{EditID ? 'Update' : 'Save'}</Button>
                    </Box>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '64vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {EditPopup ?
                <DeletePopup
                    DeletTitle={`This action will affect in consultation room mapping as well, Are you sure you want to In-Active this item ?`}
                    deleteAlertPopupClose={PopupClose.bind(this)}
                    removeData={AddConsultRoomMaster.bind(this)}
                    ButtonText={'Yes'}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`This action will affect in consultation room mapping as well, Are you sure you want to delete this item ?`}
                    DeleteNotify={"This action cannot be undone."}
                    deleteAlertPopupClose={PopupClose.bind(this)}
                    removeData={deleteConsultRoomMaster.bind(this)}
                    ButtonText={'Yes'}
                />
                : null}
            <Loader loaderOpen={isloader} />
        </Box>
    )
}